import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_PREFIX } from '../../shared/services/basic.service';
import { ErrorHandlingService } from '../../shared/services/error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalToolIntegrationModalService {
  constructor(
    private http: HttpClient,
    private ehs: ErrorHandlingService,
    private alcmeonContext: AlcmeonContextService
  ) {}

  getTaskContext(taskId: number) {
    const taskContextURL = `${API_URL_PREFIX}/api/1.0/companies/${this.alcmeonContext.companyId}/tasks/${taskId}/context-for-external-parties`;
    return this.http.get<any>(taskContextURL).pipe(this.ehs.catchAlertAndThrowHttpError());
  }
}
